import gql from 'graphql-tag';

export const LICENSE_CREATE = gql`
  mutation ($input: LicenseCreateInput!){
    licenseCreate(input: $input) {
      id
      email
      status
    }
  }

`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/licenses/create.js